import { useEffect } from 'react';
import isEqual from 'react-fast-compare';
import { ComputeContextKeys } from '../../../hooks/computeContext/const';
import type { createGlobalStateStoreSelectors } from '../selectors';
import type { BaseGlobalStateStoreProviderProps, GlobalStateStore } from '../types';

type Store = ReturnType<typeof createGlobalStateStoreSelectors>;

export function useSyncPageInputs({
  store,
  pageInputs,
  getDependencyGraphActions,
}: {
  // null when the caller is a per-instance wrapper (Module / TC) that has not
  // yet resolved the instance store (page context missing or instance not
  // registered). Effect short-circuits — see useSyncInstanceGlobalState.
  store: Store | null;
  pageInputs: BaseGlobalStateStoreProviderProps['pageInputs'];
  getDependencyGraphActions: BaseGlobalStateStoreProviderProps['getDependencyGraphActions'];
}) {
  useEffect(() => {
    if (!store) return;
    if (!isEqual(store.getState().pageInputs, pageInputs)) {
      const _pageInputs: GlobalStateStore['pageInputs'] = pageInputs ?? {};
      store.setState({ pageInputs: _pageInputs });
      getDependencyGraphActions().notifyDependencyChange({ id: ComputeContextKeys.PAGE_INPUTS });
    }
  }, [getDependencyGraphActions, pageInputs, store]);
}
